// ----------------------------------------------------------------------------
// Section: Site Header
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';
import Swiper, { A11y, Autoplay, Navigation } from 'swiper';
import 'snippets/announcement-bar/announcement-bar';
import 'snippets/menu/menu';
import 'snippets/country-switcher/country-switcher';
import 'snippets/mini-cart/mini-cart'; // TODO: include mini cart here for now.
import 'snippets/search-form/search';
import 'snippets/icon/icon';
import 'snippets/newsletter-banner/newsletter-banner';

// Styles
import './_header.scss';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';

// Optional Features
// import './header/header--sticky';

// -------------------------------------
// Variables
// -------------------------------------

var headerClass = '.header';
var menuClass = '.menu--default';
var menuToggle = '.header__link--menu';

function handleRotatingBannersSlides(swiperEl) {
    swiperEl.slides.forEach(function(slide, index, array) {
        slide.addEventListener('focus', function(e) {
            var slidePos = swiperEl.el.getBoundingClientRect();

            // Remove standard scrolling to element in focus due to it going off the screen (slides left when it needs to stay on screen)
            swiperEl.el.scrollLeft = 0;
            swiperEl.slideTo(index);

            // Emulating normal tab focus due to needing to remove standard scroll
            // If element is already in viewport, do nothing
            // Otherwise, scroll to the element and it should be in the middle of the screen when scrolling stops
            if (!(slidePos.top >=0 &&
            slidePos.left >=0 &&
            slidePos.bottom <= $(window).height() &&
            slidePos.right <= $(window).width())) {
                window.scrollTo({
                    top: (slidePos.top + window.scrollY) - ($(window).innerHeight / 2),
                    left: 0,
                    behavior: 'smooth'
                });
            }
        });
    });
}

// -------------------------------------
// Variables
// -------------------------------------
const CAROUSEL_SELECTOR = '.carousel--rotating-banners';
const CAROUSEL_CLASS = 'carousel--rotating-banners';
const CAROUSEL_SECTION_SELECTOR = '.carousel-section--rotating-banners';
const CAROUSEL_SECTION_CLASS = 'carousel-section--rotating-banners';
const CAROUSEL_PREV_BUTTON_SELECTOR = '.swiper-button-prev';
const CAROUSEL_NEXT_BUTTON_SELECTOR = '.swiper-button-next';

// -------------------------------------
// Hooks
// -------------------------------------
document.querySelectorAll(CAROUSEL_SECTION_SELECTOR)
        .forEach((element, index) => {

            // Generate unique class for each collection list slider
            element.querySelector(CAROUSEL_SELECTOR).classList.add(`${CAROUSEL_CLASS}-${index}`);

            // Generate unique btn classes for slider arrows
            element.querySelector(CAROUSEL_PREV_BUTTON_SELECTOR).classList.add(`${CAROUSEL_SECTION_CLASS}-btn-prev-${index}`);
            element.querySelector(CAROUSEL_NEXT_BUTTON_SELECTOR).classList.add(`${CAROUSEL_SECTION_CLASS}-btn-next-${index}`);

                const swiper = new Swiper(`.${CAROUSEL_CLASS}-${index}`, {
                    // Optional parameters
                    modules: [A11y, Navigation, Autoplay],
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: true
                    },
                    loop: true,
                    slidesPerView: 1,
                    spaceBetween: 15,
                    observer: true,
                    observeParents: true,
                    a11y: false,
                    watchOverflow: true,

                    // Navigation arrows
                    navigation: {
                        nextEl: `.${CAROUSEL_SECTION_CLASS}-btn-next-${index}`,
                        prevEl: `.${CAROUSEL_SECTION_CLASS}-btn-prev-${index}`
                    },
                    on: {
                        beforeInit() {
                          const slides = this.el.querySelectorAll('.swiper-slide');
                    
                          if (slides) {
                            this.params.loop = slides.length > 1;
                            this.params.autoplay.enabled = slides.length > 1;
                          }
                        },
                      }
                });

                if (swiper.slides) {
                    handleRotatingBannersSlides(swiper);
                } else {
                    swiper.forEach(function(swiperEl) {
                        handleRotatingBannersSlides(swiperEl);
                    })
                }
        })

$(document).ready(function() {

    // Generating Rotating Banners Carousel
    $(".carousel--rotating-banners").each(function(index, element){
        var $this = $(this);

        // Generate unique class for each feature collection slider
        $this.addClass("rotating-banners-instance-" + index);

        // Generate unique btn classes for slider arrows
        $this.parents('.carousel-section--rotating-banners').find(".swiper-button-next").addClass("rotating-banners-btn-next-" + index);
        $this.parents('.carousel-section--rotating-banners').find(".swiper-button-prev").addClass("rotating-banners-btn-prev-" + index);

        // Initialize feature collection slider based on the unique classes generated above.
        var swiper = new Swiper(".rotating-banners-instance-" + index, {
             // Optional parameters
            modules: [A11y, Autoplay, Navigation],
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            loop: true,
            slidesPerView: 1,
            spaceBetween: 15,
            observer: true,
            observeParents: true,
            a11y: false,
            watchOverflow: true,

            navigation: {
                nextEl: ".rotating-banners-btn-next-" + index,
                prevEl: ".rotating-banners-btn-prev-" + index,
            },
        });

        if (swiper.slides) {
            handleRotatingBannersSlides(swiper);
        } else {
            swiper.forEach(function(swiperEl) {
                handleRotatingBannersSlides(swiperEl);
            })
        }
    });

    // Unless we click inside the header,
    // we probably don't want to have open navs
    $('body').on('click', function(event) {
        if (!$(event.target).closest(menuClass).length && !$(event.target).closest('.header__container').length) {
            $(menuToggle).removeClass('js--isOpen');
            $(menuToggle).attr('aria-expanded', 'false');
            $(menuToggle).find('.sr-only').html('Open Main Menu');
            $(headerClass).removeClass('js--isOpen');
            $(menuClass).removeClass('js--isOpen');
            $('body').removeClass('noscroll--nav');
            $('.menu__item--dropdown').removeClass('js--isOpen');
        }
    });

    // Open menu on mobile
    $(menuToggle).on('click', function(event) {
        event.preventDefault();
        $(this).toggleClass('js--isOpen');
        $(this).attr('aria-expanded', (_, attr) => attr == 'false' ? 'true' : 'false');
        $(this).find('.sr-only').html((_, html) => html == 'Open Main Menu' ? 'Close Main Menu' : 'Open Main Menu');
        $(headerClass).toggleClass('js--isOpen');
        $(menuClass).toggleClass('js--isOpen');
        $('body').toggleClass('noscroll--nav');
        $('.menu__item--dropdown').removeClass('js--isOpen');

    });


    document.addEventListener('keyup', function(e) {
        if (e.key == 27 && $(menuClass).hasClass('js--isOpen') ) {
            $(menuToggle).removeClass('js--isOpen');
            $(menuToggle).attr('aria-expanded', 'false');
            $(menuToggle).find('.sr-only').html('Open Main Menu');
            $(headerClass).removeClass('js--isOpen');
            $(menuClass).removeClass('js--isOpen');
            $('body').removeClass('noscroll--nav');
        }
    });


    // // Header Sticky State
    // $(window).scroll(function(){
    //     if($(window).scrollTop() > 0) {
    //         $('.header').addClass('is-sticky');
    //         $('.announcement-bar').addClass('is-sticky');
    //     }else {
    //         $('.header').removeClass('is-sticky');
    //         $('.announcement-bar').removeClass('is-sticky');
    //     }
    // });
});
